<template>
  <div id="app">
    <Tabs :pills="false">
      <Tab key="tab-highlights" title="Highlights" lazy>
        <TabContent
          tab="Highlights"
          :contents="highlightsData"
          :apiRoute="apiRoute"
          v-model="country"
        />
      </Tab>
      <Tab key="tab-fugitive-emissions" title="Fugitive emissions" lazy>
        <TabContent
          tab="Fugitive emissions"
          :contents="fugitiveEmissionsData"
          :apiRoute="apiRoute"
          v-model="country"
        />
      </Tab>
      <Tab
        key="tab-socioeconomic-indicators"
        title="Socioeconomic indicators"
        lazy
      >
        <TabContent
          tab="Socioeconomic indicators"
          :contents="socioeconomicIndicatorsData"
          :apiRoute="apiRoute"
          v-model="country"
        />
      </Tab>
      <Tab key="tab-sectoral-anlaysis" title="Sectoral analysis" lazy>
        <TabContent
          tab="Sectoral analysis"
          :contents="sectoralAnalysisData"
          :apiRoute="apiRoute"
          v-model="country"
        />
      </Tab>
      <Tab key="tab-power-generation" title="Power generation" lazy>
        <TabContent
          tab="Power generation"
          :contents="powerGenerationData"
          :apiRoute="apiRoute"
          v-model="country"
        />
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import { Tabs, Tab } from "@international-energy-agency/vue-ui";
import TabContent from "./components/TabContent.vue";

import {
  highlightsData,
  fugitiveEmissionsData,
  socioeconomicIndicatorsData,
  sectoralAnalysisData,
  powerGenerationData,
} from "./data/explorer-data";

export default {
  name: "App",
  components: {
    Tabs,
    Tab,
    TabContent,
  },
  props: {
    test: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      country: "World",
      highlightsData,
      fugitiveEmissionsData,
      socioeconomicIndicatorsData,
      sectoralAnalysisData,
      powerGenerationData,
    };
  },
  computed: {
    apiRoute() {
      const { test } = this;
      // const apiTestRoute = "http://localhost:3000/ghg";
      const apiTestRoute = "https://api.test.iea.org/ghg";
      const apiRoute = "https://api.iea.org/ghg";
      return test ? apiTestRoute : apiRoute;
    },
  },
};
</script>
<style scoped>
.container {
  margin-top: 40px;
}
</style>
<style>
.indicator-box .m-chart--params {
  max-width: unset !important;
}
.indicator-box .data-explorer--param {
  width: unset !important;
  flex: 1;
}
.indicator-box .m-chart--params > :not(:first-child) {
  margin-left: 0 !important;
}
.highcharts-data-label span {
  white-space: nowrap !important;
}
</style>